import React from 'react'
import cx from 'classnames'

import styles from './Title.module.scss'

type Div = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export interface TitleProps extends Div {
  h?: 1 | 2 | 3
  className?: string
  variant?: 'primary' | 'secondary'
}

export const Title: React.FC<TitleProps> = ({
  h = 3,
  className,
  children,
  variant = 'primary',
  ...props
}) => {
  return (
    <div
      {...props}
      className={cx(
        styles.root,
        styles[`h${h}`],
        styles[variant],
        className,
        'title',
      )}
    >
      {children}
    </div>
  )
}
